// src/components/answering-traveller-questions/answering-traveller-questions.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment TravellerClickActionFragment on TravellerClickAction {\n    clickEvent {\n      eventName\n      eventType\n      eventVersion\n      actionLocation\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    spotLight\n    title\n    theme\n    token\n    withBackground\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    accessibility\n    disabled\n    icon {\n      ...EGDSIconFragment\n    }\n    primary\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInputFieldFragment on EGDSInputField {\n    instructions\n    label\n    placeholder\n    readOnly\n    required\n    value\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTextInputFieldFragment on EGDSTextInputField {\n    disabled\n    egdsElementId\n    ...EGDSInputFieldFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment DialogToolbarFragment on EGDSDialogToolbar {\n    closeText\n    title\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment TravellerSearchDialogFragment on TravellerSearchDialog {\n    dialogToolbar {\n      ...DialogToolbarFragment\n    }\n    searchBox {\n      ...EGDSTextInputFieldFragment\n    }\n    searchButton {\n      ...EGDSButtonFragment\n    }\n    closeAction {\n      ...TravellerClickActionFragment\n    }\n    searchAction {\n      ...TravellerClickActionFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment TravellerSearchDialogTriggerFragment on TravellerSearchDialogTrigger {\n    button {\n      ...EGDSButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment TravellerSearchFragment on TravellerSearch {\n    title\n    travellerSearchDialogTrigger {\n      ...TravellerSearchDialogTriggerFragment\n    }\n    travellerSearchDialog {\n      ...TravellerSearchDialogFragment\n    }\n    searchAction {\n      ...TravellerClickActionFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  query AnsweringTravellerQuestionsQuery($context: ContextInput!) {\n    answeringTravellerQuestions(context: $context) {\n      ...TravellerSearchFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
import React8 from "react";
import { gql as gql10, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ViewLarge as ViewLarge2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// src/components/answering-traveller-questions/__private/__fragments/traveller-search.tsx
import React7, { useCallback as useCallback2 } from "react";
import { gql as gql9 } from "@apollo/client";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { UitkParagraph } from "uitk-react-text";
// src/utils/clickstream-event-builder.ts
var clickstreamEventBuilder = function(clickstreamEventData) {
    return {
        event: {
            event_name: clickstreamEventData.eventName,
            event_type: clickstreamEventData.eventType,
            event_version: clickstreamEventData.eventVersion,
            action_location: clickstreamEventData.actionLocation
        }
    };
};
// src/components/answering-traveller-questions/common/traveller-click-action.ts
import { gql } from "@apollo/client";
var __TravellerClickActionFragment = gql(_templateObject());
// src/components/answering-traveller-questions/__private/__fragments/traveller-search-dialog.tsx
import React5, { useCallback } from "react";
import { gql as gql7 } from "@apollo/client";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
// ../internal/src/components/egds-button/egds-button.tsx
import React2 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkPrimaryButton, UitkSecondaryButton } from "uitk-react-button";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
var _obj;
// ../internal/src/components/egds-icon/__private/spotlight-mapper.ts
var spotlightMapper = (_obj = {}, _define_property(_obj, "INFO" /* INFO */ , "info"), _define_property(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj, "WARNING" /* WARNING */ , "warning"), _define_property(_obj, "STANDARD" /* STANDARD */ , "standard"), _obj);
// ../internal/src/components/egds-icon/egds-icon.tsx
var fragment = gql2(_templateObject1());
var EGDSIcon = function(param) {
    var className = param.className, defaultIconSize = param.defaultIconSize, data = param.data;
    var id = data.id, token = data.token;
    if (!id || !token) {
        return null;
    }
    var description = data.description, withBackground = data.withBackground, size = data.size, spotLight = data.spotLight, title = data.title, theme = data.theme;
    return /* @__PURE__ */ React.createElement(UitkIcon, {
        className: className,
        description: description,
        id: id,
        name: token,
        shadow: withBackground !== null && withBackground !== void 0 ? withBackground : void 0,
        size: size ? UitkIconSize[size] : defaultIconSize,
        spotlight: spotLight ? spotlightMapper[spotLight] : void 0,
        title: title !== null && title !== void 0 ? title : void 0,
        theme: theme !== null && theme !== void 0 ? theme : void 0
    });
};
EGDSIcon.fragment = fragment;
EGDSIcon.displayName = "UitkIcon";
// ../internal/src/components/egds-button/egds-button.tsx
var fragment2 = gql3(_templateObject2(), EGDSIcon.fragment);
var EGDSButton = React2.forwardRef(function(props, ref) {
    var _data;
    var data = props.data;
    var disabled = props.disabled, onClickHandler = props.onClickHandler, isFullWidth = props.isFullWidth, size = props.size, className = props.className, type = props.type;
    var __typename = data.__typename, accessibility = data.accessibility, icon = data.icon, primary = data.primary;
    var _data_disabled;
    var buttonProps = {
        disabled: disabled || ((_data_disabled = (_data = data) === null || _data === void 0 ? void 0 : _data.disabled) !== null && _data_disabled !== void 0 ? _data_disabled : void 0),
        onClick: onClickHandler,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        isFullWidth: isFullWidth,
        size: size,
        className: className,
        type: type !== null && type !== void 0 ? type : "button",
        domRef: ref !== null && ref !== void 0 ? ref : null
    };
    switch(__typename){
        case "UIPrimaryButton":
            return /* @__PURE__ */ React2.createElement(UitkPrimaryButton, _object_spread({}, buttonProps), icon && /* @__PURE__ */ React2.createElement(EGDSIcon, {
                data: icon
            }), primary || null);
        case "UISecondaryButton":
            return /* @__PURE__ */ React2.createElement(UitkSecondaryButton, _object_spread({}, buttonProps), icon && /* @__PURE__ */ React2.createElement(EGDSIcon, {
                data: icon
            }), primary || null);
        default:
            return null;
    }
});
EGDSButton.fragment = fragment2;
EGDSButton.displayName = "EGDSButton";
// ../internal/src/components/egds-text-input/egds-text-input-field.tsx
import React3 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkTextInput } from "uitk-react-input";
// ../internal/src/components/egds-text-input/egds-input-field.ts
import { gql as gql4 } from "@apollo/client";
var __EGDSInputFieldFragment = gql4(_templateObject3());
// ../internal/src/components/egds-text-input/egds-text-input-field.tsx
var fragment3 = gql5(_templateObject4(), __EGDSInputFieldFragment);
var EGDSTextInputField = function(_param) {
    var data = _param.data, rest = _object_without_properties(_param, [
        "data"
    ]);
    var disabled = data.disabled, egdsElementId = data.egdsElementId, instructions = data.instructions, label = data.label, placeholder = data.placeholder, readOnly = data.readOnly, required = data.required;
    return /* @__PURE__ */ React3.createElement(UitkTextInput, _object_spread({
        disabled: disabled !== null && disabled !== void 0 ? disabled : false,
        id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : void 0,
        instruction: instructions !== null && instructions !== void 0 ? instructions : void 0,
        label: label !== null && label !== void 0 ? label : "",
        name: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : void 0,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : void 0,
        readOnly: readOnly,
        required: required !== null && required !== void 0 ? required : false
    }, rest));
};
EGDSTextInputField.fragment = fragment3;
EGDSTextInputField.displayName = "EGDSTextInputField";
// src/components/answering-traveller-questions/__private/__fragments/traveller-search-dialog.tsx
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkButtonSize } from "uitk-react-button";
import { UitkForm } from "uitk-react-form";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
// src/components/answering-traveller-questions/__private/__fragments/dialog-toolbar.tsx
import React4 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkToolbar } from "uitk-react-toolbar";
var fragment4 = gql6(_templateObject5());
var DialogToolbar = function(param) {
    var data = param.data, closeDialog = param.closeDialog;
    var title = data.title, closeText = data.closeText;
    return /* @__PURE__ */ React4.createElement(UitkToolbar, {
        navigationContent: {
            onClick: function(event) {
                closeDialog(event);
            },
            navIconLabel: closeText !== null && closeText !== void 0 ? closeText : "",
            navButtonId: "traveller-search-dialog-close"
        },
        toolbarTitle: title
    });
};
DialogToolbar.fragment = fragment4;
DialogToolbar.displayName = "DialogToolbar";
// src/components/answering-traveller-questions/__private/__fragments/traveller-search-dialog.tsx
var fragment5 = gql7(_templateObject6(), DialogToolbar.fragment, EGDSTextInputField.fragment, EGDSButton.fragment, __TravellerClickActionFragment);
var TravellerSearchDialog = function(param) {
    var data = param.data, _param_triggerRef = param.triggerRef, triggerRef = _param_triggerRef === void 0 ? null : _param_triggerRef;
    var _React5_useState = _sliced_to_array(React5.useState(""), 2), inputValue = _React5_useState[0], setInputValue = _React5_useState[1];
    var track = useEgClickstream();
    var _useDialog = _sliced_to_array(useDialog("traveller-search-dialog"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var dialogToolbar = data.dialogToolbar, searchBox = data.searchBox, searchButton = data.searchButton, searchAction = data.searchAction, closeAction = data.closeAction;
    var closeDialog = useCallback(function() {
        var _closeAction;
        dialogActions.closeDialog();
        if ((_closeAction = closeAction) === null || _closeAction === void 0 ? void 0 : _closeAction.clickEvent) {
            var _closeAction_clickEvent = closeAction.clickEvent, eventName = _closeAction_clickEvent.eventName, eventType = _closeAction_clickEvent.eventType, eventVersion = _closeAction_clickEvent.eventVersion, actionLocation = _closeAction_clickEvent.actionLocation;
            var clickstreamEventData = {
                eventName: eventName,
                eventVersion: eventVersion,
                eventType: eventType,
                actionLocation: actionLocation || ""
            };
            var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
            track(clickstreamEvent);
        }
    }, [
        dialogActions,
        closeAction,
        track
    ]);
    var handleSubmit = useCallback(function(event) {
        var _searchAction;
        event.preventDefault();
        if ((_searchAction = searchAction) === null || _searchAction === void 0 ? void 0 : _searchAction.clickEvent) {
            var _searchAction_clickEvent = searchAction.clickEvent, eventName = _searchAction_clickEvent.eventName, eventType = _searchAction_clickEvent.eventType, eventVersion = _searchAction_clickEvent.eventVersion, actionLocation = _searchAction_clickEvent.actionLocation;
            var clickstreamEventData = {
                eventName: eventName,
                eventVersion: eventVersion,
                eventType: eventType,
                actionLocation: actionLocation || ""
            };
            var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
            track(clickstreamEvent);
        }
    }, [
        searchAction,
        track
    ]);
    var handleChange = useCallback(function(event) {
        var value = event.target.value;
        setInputValue(value);
    }, [
        setInputValue
    ]);
    var uitkSheetContent = /* @__PURE__ */ React5.createElement(UitkSheetContent, null, /* @__PURE__ */ React5.createElement(UitkForm, {
        onSubmit: handleSubmit
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlex, {
        space: "three"
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem, null, searchBox && /* @__PURE__ */ React5.createElement(EGDSTextInputField, {
        data: searchBox,
        size: 100,
        hasClearButton: true,
        value: inputValue,
        onChange: handleChange
    })), /* @__PURE__ */ React5.createElement(Viewport, null, /* @__PURE__ */ React5.createElement(ViewSmall, null), /* @__PURE__ */ React5.createElement(ViewMedium, null, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem, null, searchButton && /* @__PURE__ */ React5.createElement(EGDSButton, {
        data: searchButton,
        type: "submit",
        size: UitkButtonSize.LARGE,
        disabled: inputValue.length === 0
    })))))));
    var dialogToolbarChild = /* @__PURE__ */ React5.createElement(React5.Fragment, null, dialogToolbar && /* @__PURE__ */ React5.createElement(DialogToolbar, {
        data: dialogToolbar,
        closeDialog: closeDialog
    }));
    var uitkSheet = /* @__PURE__ */ React5.createElement(UitkSheet, {
        isVisible: isDialogOpen,
        type: "centered",
        triggerRef: triggerRef,
        height: 594
    }, dialogToolbarChild, uitkSheetContent);
    return /* @__PURE__ */ React5.createElement(DialogComponent, null, /* @__PURE__ */ React5.createElement(Viewport, null, /* @__PURE__ */ React5.createElement(ViewSmall, null, /* @__PURE__ */ React5.createElement(UitkSheet, {
        isVisible: isDialogOpen,
        type: "full",
        triggerRef: triggerRef
    }, dialogToolbarChild, uitkSheetContent)), /* @__PURE__ */ React5.createElement(ViewMedium, null, uitkSheet), /* @__PURE__ */ React5.createElement(ViewLarge, null, uitkSheet)));
};
TravellerSearchDialog.fragment = fragment5;
TravellerSearchDialog.displayName = "TravellerSearchDialog";
// src/components/answering-traveller-questions/__private/__fragments/traveller-search-dialog-trigger.tsx
import React6 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize2 } from "uitk-react-button";
import { UitkSpacing } from "uitk-react-spacing";
var fragment6 = gql8(_templateObject7(), EGDSButton.fragment);
var TravellerSearchDialogTrigger = React6.forwardRef(function(props, ref) {
    var _data_button, _data;
    var data = props.data, onClickHandler = props.onClickHandler;
    if (!((_data = data) === null || _data === void 0 ? void 0 : (_data_button = _data.button) === null || _data_button === void 0 ? void 0 : _data_button.primary)) {
        return null;
    }
    var button = data.button;
    return /* @__PURE__ */ React6.createElement(UitkSpacing, {
        margin: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React6.createElement(EGDSButton, {
        size: UitkButtonSize2.MEDIUM,
        isFullWidth: false,
        data: button,
        ref: ref,
        onClickHandler: onClickHandler
    }));
});
TravellerSearchDialogTrigger.fragment = fragment6;
TravellerSearchDialogTrigger.displayName = "TravellerSearchDialogTrigger";
// src/components/answering-traveller-questions/__private/__fragments/traveller-search.tsx
var fragment7 = gql9(_templateObject8(), TravellerSearchDialogTrigger.fragment, TravellerSearchDialog.fragment, __TravellerClickActionFragment);
var TravellerSearch = function(param) {
    var data = param.data;
    var travellerSearchDialogTrigger = data.travellerSearchDialogTrigger, title = data.title, travellerSearchDialog = data.travellerSearchDialog, searchAction = data.searchAction;
    var track = useEgClickstream2();
    var _useDialog2 = _sliced_to_array(useDialog2("traveller-search-dialog"), 2), dialogActions = _useDialog2[1];
    var searchDialogTriggerRef = React7.useRef(null);
    var handleSearchDialogTriggerClick = useCallback2(function() {
        var _searchAction;
        dialogActions.openDialog();
        if ((_searchAction = searchAction) === null || _searchAction === void 0 ? void 0 : _searchAction.clickEvent) {
            var _searchAction_clickEvent = searchAction.clickEvent, eventName = _searchAction_clickEvent.eventName, eventType = _searchAction_clickEvent.eventType, eventVersion = _searchAction_clickEvent.eventVersion, actionLocation = _searchAction_clickEvent.actionLocation;
            var clickstreamEventData = {
                eventName: eventName,
                eventVersion: eventVersion,
                eventType: eventType,
                actionLocation: actionLocation || ""
            };
            var clickstreamEvent = clickstreamEventBuilder(clickstreamEventData);
            track(clickstreamEvent);
        }
    }, [
        dialogActions,
        searchAction,
        track
    ]);
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, title && /* @__PURE__ */ React7.createElement(UitkParagraph, {
        size: 2
    }, title), travellerSearchDialogTrigger && /* @__PURE__ */ React7.createElement(TravellerSearchDialogTrigger, {
        data: travellerSearchDialogTrigger,
        onClickHandler: handleSearchDialogTriggerClick,
        ref: searchDialogTriggerRef
    }), travellerSearchDialog && /* @__PURE__ */ React7.createElement(TravellerSearchDialog, {
        data: travellerSearchDialog,
        triggerRef: searchDialogTriggerRef
    }));
};
TravellerSearch.fragment = fragment7;
TravellerSearch.displayName = "TravellerSearch";
// src/components/answering-traveller-questions/answering-traveller-questions.tsx
var __Query = gql10(_templateObject9(), TravellerSearch.fragment);
var AnsweringTravellerQuestions = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.answeringTravellerQuestions) {
        return null;
    }
    var answeringTravellerQuestions = data.answeringTravellerQuestions;
    var travellerSearch = /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(TravellerSearch, {
        data: answeringTravellerQuestions
    }));
    return /* @__PURE__ */ React8.createElement(Viewport2, null, /* @__PURE__ */ React8.createElement(ViewLarge2, null, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        margin: {
            blockstart: "two"
        }
    }, travellerSearch)), /* @__PURE__ */ React8.createElement(ViewSmall2, null, /* @__PURE__ */ React8.createElement(UitkSpacing2, {
        margin: {
            blockstart: "six"
        }
    }, travellerSearch)));
};
AnsweringTravellerQuestions.displayName = "AnsweringTravellerQuestions";
export { AnsweringTravellerQuestions };
//# sourceMappingURL=index.js.map